import PropTypes from "prop-types";
// @mui
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Typography,
  TableContainer,
} from "@mui/material";
// utils
// components
import Label from "src/components/Label";
import { formatAsINR } from "src/sections/@dashboard/general/analytics/AnalyticsTrafficBySite";
import { getStatusColor } from ".";

// ----------------------------------------------------------------------

OrderedProduct.propTypes = {
  products: PropTypes.array.isRequired,
};

export default function OrderedProduct({ products, row }) {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="left">PID</TableCell>
            <TableCell align="left">VID</TableCell>
            <TableCell>Product</TableCell>
            <TableCell align="left">Status</TableCell>
            <TableCell align="left">Price</TableCell>
            <TableCell align="left">Quantity</TableCell>
            <TableCell align="right">Total Price</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {products?.map((product, index) => {
            const { prodName, price, qty, amount, productID, variationId } =
              product;
            const color = getStatusColor(product?.status);

            return (
              <TableRow key={index}>
                {/* 1. PID */}
                <TableCell align="left" sx={{ paddingLeft: "16px !important" }}>
                  <Typography variant="body2">{productID ?? "—"}</Typography>
                </TableCell>

                {/* 2. VID */}
                <TableCell align="left" sx={{ paddingLeft: "16px !important" }}>
                  <Typography variant="body2">{variationId ?? "—"}</Typography>
                </TableCell>

                {/* 3. Product */}
                <TableCell>
                  <Typography
                    noWrap
                    variant="subtitle2"
                    sx={{
                      maxWidth: 190,
                      wordBreak: "break-all",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {prodName}
                  </Typography>
                  {product.sizeComment && (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "block", mt: 0.5 }}
                    >
                      {product.sizeComment}
                    </Typography>
                  )}
                </TableCell>

                {/* 4. Status */}
                <TableCell align="left" sx={{ paddingLeft: "16px !important" }}>
                  <Label color={color || "success"}>{product?.status}</Label>
                </TableCell>

                {/* 5. Price */}
                <TableCell align="left" sx={{ paddingLeft: "16px !important" }}>
                  {formatAsINR(price)}
                </TableCell>

                {/* 6. Quantity */}
                <TableCell align="left" sx={{ paddingLeft: "16px !important" }}>
                  {qty}
                </TableCell>

                {/* 7. Total Price */}
                <TableCell
                  align="right"
                  sx={{ paddingLeft: "16px !important" }}
                >
                  {formatAsINR(amount)}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
